export const SetUser = user => dispatch => {
  dispatch({ type: 'ADDUSER', data: user });
};
export const SetAnsw = answ => dispatch => {
  dispatch({ type: 'ADDANSW', data: answ });
};

export const SubAnsw = answ => dispatch => {
  dispatch({ type: 'SUBANSW', data: answ });
};
